import { FC } from 'react';
import NoContentImage from '../../../assets/image/notItens.png';
import * as Styled from './styles';
import { EmptyList } from '@praticabr/ppsa';

type Props = {
  title?: string;
  description?: string;
  multilist?: boolean;
  isVertical?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
};

const NoContent: FC<Props> = ({ title, description, multilist, isVertical, size }) => (
  <EmptyList title={title} description={description} multilist={multilist} isVertical={isVertical} size={size} />
);

export default NoContent;
